import { DatePipe, CurrencyPipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private getHeaders() {
    return new HttpHeaders({
      authorization: localStorage.getItem("usertoken") as any,
    })
  }

  constructor(
    private datePipe: DatePipe,
    private http: HttpClient,
    private currencyPipe: CurrencyPipe
  ) { }

  public printBookingReceipt(printData: any, justWantHtml?: any): any {
    var innerHTML = `
      <div id="ids" class="row d-flex justify-content-between" >
        <span><b>PaymentID: </b>${printData.payment.payment_id ? printData.payment.payment_id : '-'}</span>
        <span><b>OrderID: </b>${printData.payment.order_id ? printData.payment.order_id : '-'}</span>
      </div>
      <hr/>
      <div class="row">
        <div class="col-6">
          <span>${printData.program.name}</span>
            <ul class="proram-list">`
    for (let index = 0; index < printData.slots.length; index++) {
      const element = printData.slots[index];
      innerHTML = innerHTML + `<li class="d-block" >
                    <div class="brand-content d-flex justify-content-between" >
                      <span class="b-slot-date cursor" >
                        ${this.datePipe.transform(element.start_date, 'dd MMM, y')} - ${element.days}
                      </span>
                      <span class="b-slot-text-right" >
                        <i> 
                          ${element.start_time} - ${element.end_time}  
                        </i>
                      </span>
                    </div>
                    `
      if (element.parentName) {
        innerHTML = innerHTML +
          `<div class="brand-content">
                          <span class="b-program-text cursor"> 
                            ${element.parentName}
                          </span>
                          <span class="b-program-text-right" >
                             $${printData.program.booking_cost}
                          </span>
                        </div> `
      }
      if (element.childNames) {
        for (let i = 0; i < element.childNames.length; i++) {
          const children = element.childNames[i];
          innerHTML = innerHTML +
            `<div class="brand-content">
                          <span class="b-program-text cursor"> ${children}</span>
                          <span class="b-program-text-right">
                              $${printData.program.booking_cost} 
                          </span>
                        </div>
                        `
        }
      }
    }
    innerHTML = innerHTML + `</li>
          </ul>
        </div>
        <div class="col-6 mt-4">
          <span class="d-block"> 
            <b>Payment Mode: </b> ${printData.payment.source_type}
          </span>
          <span class="d-block"> 
            <b>Total Amount: </b> $${printData.payment.total_amount}
          </span>
          <span class="d-block"> 
            <b>Total Seats Booked: </b> ${printData.payment.total_seats_booked}
          </span>
        </div>
      </div>
  `;

    if (justWantHtml) {
      return innerHTML;
    }
    let skeleton = `
  <html>
        <head>
        <title>WeFroth</title>
        <link
          rel="shortcut icon"
          type="image/png"
          href="assets/img/logo-wefrothfav.png" sizes="16x16"
        />
        <base href="/" />
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
        <link rel="stylesheet" href="assets/css/main.css" />
        <link rel="stylesheet" href="assets/css/responsive.css" />
        <link rel="stylesheet" href="assets/css/loading.css" />
        <link rel="stylesheet" href="assets/css/style.css" />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.7.2/css/all.css"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700,800,900"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Nanum+Gothic:400,700,800"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.12/dist/css/bootstrap-select.min.css">
        <!-- <link
          href="https://cdn.datatables.net/1.10.19/css/dataTables.bootstrap4.min.css"
          rel="stylesheet"
        />
        <link
          href="https://cdn.datatables.net/responsive/2.2.3/css/responsive.bootstrap4.min.css"
          rel="stylesheet"
        /> -->


        <!-- inline spinner styles to be able to display spinner right away -->
        <style type="text/css">
          body,
          html {
            height: 100%;
            background-color: #f0f0f0;
            padding: 25px;
          }


            .d-print-none {
              display: none;
            }

            .slot-date{
              color: #707070;
            }
            
            .slot-text-right {
              float: right;
            }
          
            .program-text {
              color: black;
              font-weight: bold;
            }
            
            .program-text-right {
              color: #47a173;
              float: right;
            }
            </style>

            </head>
          <body>${innerHTML}</body>
          </html>
      `

    var frame1: any = document.createElement('iframe');
    frame1.name = "frame1";
    frame1.style.position = "absolute";
    frame1.style.top = "-1000000px";
    document.body.appendChild(frame1);
    var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument['document'] ? frame1.contentDocument['document'] : frame1.contentDocument;
    frameDoc.document.open();
    frameDoc.document.write(skeleton);
    frameDoc.document.close();
    setTimeout(function () {
      (window as any).frames["frame1"].focus();
      (window as any).frames["frame1"].print();
      document.body.removeChild(frame1);
    }, 500);
  }

  public printPDF(Obj: any) {
    var url = environment.API_ENDPOINT + "v1/common/generate-pdf";
    return this.http
      .post(url, Obj, {
        headers: this.getHeaders(),
      });
  }

  public parseUrls(Obj: any) {
    var url = environment.API_ENDPOINT + "v1/common/parse-url";
    return this.http
      .post(url, Obj, {
        headers: this.getHeaders(),
      });
  }

  validURL(str: any) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  transformAmount(element: any) {
    let valueToBeUpdated = 0;
    if (typeof element === 'object') {
      valueToBeUpdated = isNaN(element.target.value) ? 0 : parseInt(element.target.value, 10);
      element.target.value = this.currencyPipe.transform(valueToBeUpdated, '$');
      element.target.value = element.target.value;
    } else {
      valueToBeUpdated = isNaN(element) ? 0 : parseInt(element, 10);
      element = this.currencyPipe.transform(valueToBeUpdated, '$');
      return element;
    }
  }

  getPromotionalBanner() {
    var url = environment.API_ENDPOINT + "v1/promotion/getPromotionalBanner";
    return this.http
      .get(url, {
        // headers: new HttpHeaders({
        //     authorization: localStorage.getItem("usertoken") as any,
        // }),
      })
  }
  getPhotosGallery(page: any = 1, offset: any = 10) {
    var url = environment.API_ENDPOINT + "v1/home/getPhotosGallery?currentPage=" + page + "&itemsPerPage=" + offset + "";
    return this.http
      .get(url, {
        // headers: new HttpHeaders({
        //     authorization: localStorage.getItem("usertoken") as any,
        // }),
      })
  }
  getActiveVideosList(page: any = 1, offset: any = 10) {
    var url = environment.API_ENDPOINT + "v1/home/getActiveVideosList?currentPage=" + page + "&itemsPerPage=" + offset + "";
    return this.http
      .get(url, {
        // headers: new HttpHeaders({
        //     authorization: localStorage.getItem("usertoken") as any,
        // }),
      })
  }
}
